//import { HashLink } from 'react-router-hash-link';
import { useState, useEffect, ChangeEvent, useLayoutEffect } from 'react';
import { BackToTop } from "material-ui-back-to-top";
import axios from 'axios';
import qs from 'qs';

import _traits from './data/traits.json';

import { Link as RouterLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Link from '@material-ui/core/Link';

// COMPONENTS
import Header from './components/Header';
import Footer from './components/Footer';

// MUI
import { makeStyles } from '@material-ui/core/styles';
import { Container , Button , Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/lab/Pagination';

import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
//import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
// import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';

// import collectionPage from "./assets/collection-page.jpg";
// import collectionPageMobile from "./assets/collection-page-mobile.png";

const Collections = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  });

  let [collectionsData, setCollectionsData] = useState<any>([]);
  let [paginationCount, setPaginationCount] = useState<number>(0);
  let [position, setPosition] = useState<number>(0);
  let [filter, setFilter] = useState<string>('');
  let [value, setValue] = useState<string>('ascending');
  let [currentPage, setCurrentPage] = useState<number>(1);
  let [searchParams, setSearchParams] = useSearchParams();
  let [currentView, setCurrentView] = useState<string>('nfts');
  let [traitsData, setTraitsData] = useState<any>([]);

  interface QueryParams {
    position?: number;
    filter?: string;
    rarity?: Boolean;
    traits?: string;
    traitsFilter?: string;
  }
  
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const query: QueryParams = qs.parse(location.search, { ignoreQueryPrefix: true } );

    handleFilters(event.target.value, query.traits);
    setValue((event.target as HTMLInputElement).value);
  };

  const getCollections = (pos: number, filter?: string) => {
    setCurrentView('nfts');
    const baseURL = 'https://8nodvga7s5.execute-api.us-east-1.amazonaws.com/test/collections';
    axios.get(baseURL, { 
      params: {
        position: pos ? pos : 0,
        filter: filter ? filter : ''
      }
    }).then((response) => {
      setPaginationCount(response.data.totalCount);
      setCollectionsData(response.data.collections);
    });
  };

  const getTraits = (filter?: string) => {
    setCurrentView('traits');

    if (filter === 'All' || !filter) {
      setTraitsData(_traits);
    } else {
      const content = _traits.find(trait => trait.trait_type === filter);
      setTraitsData([content]);
    }
  };

  const getQueryParameters = () => {
    const query: QueryParams = qs.parse(location.search, { ignoreQueryPrefix: true } );

    if (query.traits === 'true') {
      getTraits(query.filter);
    } else {
      if (query.position) {
        setPosition(query.position);
        getCollections(query.position, query.filter);
      } else {
        setPosition(0);
        getCollections(0);
      }
    }
  };

  let navigate = useNavigate();

  const handlePagination = (event: object, page: number) => {
    const amountPerPage = 24;
    let pos = page == 1 ? 0 : ((amountPerPage * page) - amountPerPage);
    
    const params = qs.stringify({
      position: pos,
      filter: filter ? filter : ''
    });
    
    setCurrentPage(page);
    setSearchParams(params);
    window.scrollTo(0, 0);
  };

  const handleFilters = (filter: string, traits?: string) => {
    const params = qs.stringify({
      position: 0,
      filter: filter ? filter : '',
      traits: traits ? traits : 'false'
    });
    
    setCurrentPage(1);
    setFilter(filter);
    setSearchParams(params);
    window.scrollTo(0, 0);
  };

  // useEffect(() => {
  //   getCollections();
  // }, [position]);

  const location = useLocation();

  useEffect(() => {
    getQueryParameters();
  }, [location]);

  // CUSTOM STYLES FOR PAGE
  const useStyles = makeStyles((theme) => ({
    "@global": {
      body: {
        backgroundColor: "#fff",
        margin: 0,
      },
      a: {
        textDecoration: 'none',
        color: '#9334ff',
        cursor: 'hand'
      }
    },
    root: {
      flexGrow: 1,
    },
    list: {
      lineHeight: '1.5',
      margin: 0,
      paddingLeft: 15,
      color: '#8c8c8c',
      '& li': {
        padding: '0 0 20px',
      },
    },
    innerList: {
      padding: '10px 24px',
      '& li': {
        fontSize: 'small',
      },
      '& li:last-child': {
        padding: 0,
      }
    },
    bodyPaper: {
      color: '#000',
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    step: {
      marginBottom: '30px',
      '& .header': {
        marginBottom: 14
      },
      '& .body': {
        color: '#8c8c8c'
      }
    },
    inPageNavigation: {
      '& Button': {
        [theme.breakpoints.down('sm')]: {
          width: '100%'
        },
      },
    },
    pagination: {
      '& li button': {
        color: '#333'
      }
    },
    accordion: {
      background: 'none',
      boxShadow: 'none',
      borderRadius: '0 !important',
      color: 'black'
    },
    dFlex: {
      display: 'flex'
    },
    justifyContentEnd: {
      justifyContent: 'flex-end'
    },
    inputColor: {
      color: '#9334ff !important'
    },
    itemImage: {
      display: 'flex',
      justifyContent: 'center',
      padding: '15px',
      '& img': {
        borderRadius: '5px'
      }
    },
    paper: {
      background: 'white',
      boxShadow: '0px 0px 5px 1px rgb(0 0 0 / 20%)'
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    }
  }));

  const classes = useStyles();

  const [alignment, setAlignment] = useState<string | null>('left');

  const handleAlignment = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  // const renderSideBarTop = () => {
  //   if (window.location.host == 'localhost:3000') {
  //     return (
  //       <div>
          
  //       </div>
  //     );
  //   }
  // };

  return (
    <div className={classes.root}>
        <Header />
        <Container>
          {/* main content goes here */}
          <Paper elevation={0} className={classes.bodyPaper}>
            <Container style={{ padding: '30px 22px', textAlign: 'left' }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={3}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Link component={RouterLink} to="/collections" style={{ textDecoration: 'none' }}>
                        {currentView === 'nfts' ?
                          <Button style={{ background: '#9334ff', color: 'white' }} variant="contained" size="small" fullWidth={true}>BUNNY</Button>
                          :
                          <Button style={{ color: '#939393', borderColor: '#939393' }} variant="outlined" size="small" fullWidth={true}>BUNNY</Button>
                        }
                      </Link>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Link component={RouterLink} to="/collections?traits=true" style={{ textDecoration: 'none' }}>
                        {currentView === 'traits' ?
                          <Button style={{ background: '#9334ff', color: 'white' }} variant="contained" size="small" fullWidth={true}>OUTFIT</Button>
                          :
                          <Button style={{ color: '#939393', borderColor: '#939393' }} variant="outlined" size="small" fullWidth={true}>OUTFIT</Button>
                        }
                      </Link>
                    </Grid>
                  </Grid>

                  <ToggleButtonGroup 
                    className={`${classes.dFlex} ${classes.justifyContentEnd} ${classes.sectionDesktop}`} 
                    orientation="horizontal" 
                    exclusive
                    value={alignment}
                    onChange={handleAlignment}
                    aria-label="grid view"
                  >
                    <ToggleButton value="list" aria-label="list">
                      <ViewModuleIcon style={{color: '#9334ff'}} />
                    </ToggleButton>

                    <ToggleButton value="module" aria-label="module">
                      <ViewComfyIcon style={{color: '#9334ff'}} />
                    </ToggleButton>

                  </ToggleButtonGroup>

                  <Grid container spacing={2}>
                    {/* ORDER BY SECTION */}
                    {/* <Grid item xs={12}>  
                      <Accordion className={classes.accordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{borderBottom: '1px solid black', padding: '0'}}
                        >
                          <Typography>SORT BY</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{padding: '5px 0'}}>
                          <FormControl component="fieldset">
                            <RadioGroup aria-label="rarity" name="rarity" value={value} onChange={handleChange}>
                              <FormControlLabel value="ascending" control={<Radio className={classes.inputColor} />} label="Rarity Ascending" />
                              <FormControlLabel value="descending" control={<Radio className={classes.inputColor} />} label="Rarity Descending" />
                            </RadioGroup>
                          </FormControl>
                        </AccordionDetails>
                      </Accordion>
                    </Grid> */}
                    
                    {/* traits nav */}
                    {currentView == 'traits' ? 
                      <Grid item xs={12} md={12}>
                        <Accordion className={classes.accordion} defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{borderBottom: '1px solid black', padding: '0'}}
                          >
                            <Typography>TRAITS</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '5px 0' }}>
                            <RadioGroup aria-label="filters" name="filters" value={value} onChange={handleChange} style={{ width: '100%', paddingLeft: '20px' }}>
                              <FormControlLabel value="All" control={<Radio className={classes.inputColor} />} label="All" />
                              <FormControlLabel value="Hat" control={<Radio className={classes.inputColor} />} label="Head" />
                              <FormControlLabel value="Cloth" control={<Radio className={classes.inputColor} />} label="Clothing" />
                              <FormControlLabel value="Mouth" control={<Radio className={classes.inputColor} />} label="Mouth" />
                              <FormControlLabel value="Bonus" control={<Radio className={classes.inputColor} />} label="Bonus" />
                              <FormControlLabel value="Body" control={<Radio className={classes.inputColor} />} label="Body" />
                              <FormControlLabel value="Eyes" control={<Radio className={classes.inputColor} />} label="Eyewear" />
                              <FormControlLabel value="Background" control={<Radio className={classes.inputColor} />} label="Background" />
                            </RadioGroup>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                      :
                      <Grid item xs={12} md={12}>
                        {/* OUTFITS SECTION */}
                        <Accordion className={classes.accordion} defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{borderBottom: '1px solid black', padding: '0'}}
                          >
                            <Typography>OUTFITS</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: '5px 0' }}>
                            <RadioGroup aria-label="filters" name="filters" value={value} onChange={handleChange} style={{ width: '100%', paddingLeft: '20px' }}>
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>All</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="" control={<Radio className={classes.inputColor} />} label="All" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>Head</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="Hats,Cowboy" control={<Radio className={classes.inputColor} />} label="Cowboy" />
                                  <FormControlLabel value="Hats,Pharoah" control={<Radio className={classes.inputColor} />} label="Pharoah" />
                                  <FormControlLabel value="Hats,Elvis" control={<Radio className={classes.inputColor} />} label="Elvis" />
                                  <FormControlLabel value="Hats,Headband" control={<Radio className={classes.inputColor} />} label="Headband" />
                                  <FormControlLabel value="Hats,Lei" control={<Radio className={classes.inputColor} />} label="Lei" />
                                  <FormControlLabel value="Hats,WitchHat" control={<Radio className={classes.inputColor} />} label="Witch" />
                                  <FormControlLabel value="Hats,Pirate" control={<Radio className={classes.inputColor} />} label="Pirate" />
                                  <FormControlLabel value="Hats,Cap" control={<Radio className={classes.inputColor} />} label="Cap" />
                                  <FormControlLabel value="Hats,Crown" control={<Radio className={classes.inputColor} />} label="Crown" />
                                  <FormControlLabel value="Hats,Bandana" control={<Radio className={classes.inputColor} />} label="Bandana" />
                                  <FormControlLabel value="Hats,Panama" control={<Radio className={classes.inputColor} />} label="Panama" />
                                  <FormControlLabel value="Hats,Halo" control={<Radio className={classes.inputColor} />} label="Halo" />
                                  <FormControlLabel value="Hats,Astro" control={<Radio className={classes.inputColor} />} label="Astro" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>Clothing</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="Cloth,Doc" control={<Radio className={classes.inputColor} />} label="Doc" />
                                  <FormControlLabel value="Cloth,Hoodie" control={<Radio className={classes.inputColor} />} label="Hoodie" />
                                  <FormControlLabel value="Cloth,Suit" control={<Radio className={classes.inputColor} />} label="Suit" />
                                  <FormControlLabel value="Cloth,TurtleNeck" control={<Radio className={classes.inputColor} />} label="TurtleNeck" />
                                  <FormControlLabel value="Cloth,Scarf" control={<Radio className={classes.inputColor} />} label="Scarf" />
                                  <FormControlLabel value="Cloth,MoneyBag" control={<Radio className={classes.inputColor} />} label="MoneyBag" />
                                  <FormControlLabel value="Cloth,Cloak" control={<Radio className={classes.inputColor} />} label="Cloak" />
                                  <FormControlLabel value="Cloth,Astro" control={<Radio className={classes.inputColor} />} label="Astro" />
                                  <FormControlLabel value="Cloth,FurCoat" control={<Radio className={classes.inputColor} />} label="FurCoat" />
                                  <FormControlLabel value="Cloth,Cape" control={<Radio className={classes.inputColor} />} label="Cape" />
                                  <FormControlLabel value="Cloth,Robe" control={<Radio className={classes.inputColor} />} label="Robe" />
                                  <FormControlLabel value="Cloth,Tshirt" control={<Radio className={classes.inputColor} />} label="Tshirt" />
                                  <FormControlLabel value="Cloth,Hawaiian" control={<Radio className={classes.inputColor} />} label="Hawaiian" />
                                  <FormControlLabel value="Cloth,Leather" control={<Radio className={classes.inputColor} />} label="Leather" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>Mouth</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="Mouths,4Leaf" control={<Radio className={classes.inputColor} />} label="4Leaf" />
                                  <FormControlLabel value="Mouths,Ahh" control={<Radio className={classes.inputColor} />} label="Ahh" />
                                  <FormControlLabel value="Mouths,Carrot" control={<Radio className={classes.inputColor} />} label="Carrot" />
                                  <FormControlLabel value="Mouths,Drool" control={<Radio className={classes.inputColor} />} label="Drool" />
                                  <FormControlLabel value="Mouths,Gum" control={<Radio className={classes.inputColor} />} label="Gum" />
                                  <FormControlLabel value="Mouths,Hmmph" control={<Radio className={classes.inputColor} />} label="Hmmph" />
                                  <FormControlLabel value="Mouths,Mask" control={<Radio className={classes.inputColor} />} label="Mask" />
                                  <FormControlLabel value="Mouths,Normal" control={<Radio className={classes.inputColor} />} label="Normal" />
                                  <FormControlLabel value="Mouths,Normal2" control={<Radio className={classes.inputColor} />} label="Normal2" />
                                  <FormControlLabel value="Mouths,Pacifier" control={<Radio className={classes.inputColor} />} label="Pacifier" />
                                  <FormControlLabel value="Mouths,Pipe" control={<Radio className={classes.inputColor} />} label="Pipe" />
                                  <FormControlLabel value="Mouths,Pizza" control={<Radio className={classes.inputColor} />} label="Pizza" />
                                  <FormControlLabel value="Mouths,Tongue" control={<Radio className={classes.inputColor} />} label="Tongue" />
                                  <FormControlLabel value="Mouths,Wheat" control={<Radio className={classes.inputColor} />} label="Wheat" />
                                  <FormControlLabel value="Mouths,WShape" control={<Radio className={classes.inputColor} />} label="WShape" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>Bonus</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="Bonus,Fire" control={<Radio className={classes.inputColor} />} label="Fire" />
                                  <FormControlLabel value="Bonus,GoldPass" control={<Radio className={classes.inputColor} />} label="Gold Pass" />
                                  <FormControlLabel value="Bonus,SilverPass" control={<Radio className={classes.inputColor} />} label="Silver Pass" />
                                  <FormControlLabel value="Bonus,Sparkling" control={<Radio className={classes.inputColor} />} label="Sparkling" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>Body</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="Body,Blue" control={<Radio className={classes.inputColor} />} label="Blue" />
                                  <FormControlLabel value="Body,Gold" control={<Radio className={classes.inputColor} />} label="Gold" />
                                  <FormControlLabel value="Body,Green" control={<Radio className={classes.inputColor} />} label="Green" />
                                  <FormControlLabel value="Body,Grey" control={<Radio className={classes.inputColor} />} label="Grey" />
                                  <FormControlLabel value="Body,Mummy" control={<Radio className={classes.inputColor} />} label="Mummy" />
                                  <FormControlLabel value="Body,Panda" control={<Radio className={classes.inputColor} />} label="Panda" />
                                  <FormControlLabel value="Body,Pink" control={<Radio className={classes.inputColor} />} label="Pink" />
                                  <FormControlLabel value="Body,Purple" control={<Radio className={classes.inputColor} />} label="Purple" />
                                  <FormControlLabel value="Body,White" control={<Radio className={classes.inputColor} />} label="White" />
                                  <FormControlLabel value="Body,Yellow" control={<Radio className={classes.inputColor} />} label="Yellow" />
                                  <FormControlLabel value="Body,Zombie" control={<Radio className={classes.inputColor} />} label="Zombie" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>Eyewear</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="Eyes,Angry" control={<Radio className={classes.inputColor} />} label="Angry" />
                                  <FormControlLabel value="Eyes,Flat" control={<Radio className={classes.inputColor} />} label="Flat" />
                                  <FormControlLabel value="Eyes,Love" control={<Radio className={classes.inputColor} />} label="Love" />
                                  <FormControlLabel value="Eyes,Monocle" control={<Radio className={classes.inputColor} />} label="Monocle" />
                                  <FormControlLabel value="Eyes,Normal" control={<Radio className={classes.inputColor} />} label="Normal" />
                                  <FormControlLabel value="Eyes,Patch" control={<Radio className={classes.inputColor} />} label="Patch" />
                                  <FormControlLabel value="Eyes,Shine" control={<Radio className={classes.inputColor} />} label="Shine" />
                                  <FormControlLabel value="Eyes,ShutterShades" control={<Radio className={classes.inputColor} />} label="Shutter Shades" />
                                  <FormControlLabel value="Eyes,Ski" control={<Radio className={classes.inputColor} />} label="Ski" />
                                  <FormControlLabel value="Eyes,Smug" control={<Radio className={classes.inputColor} />} label="Smug" />
                                  <FormControlLabel value="Eyes,Sunglasses" control={<Radio className={classes.inputColor} />} label="Sunglasses" />
                                  <FormControlLabel value="Eyes,Teary" control={<Radio className={classes.inputColor} />} label="Teary" />
                                  <FormControlLabel value="Eyes,UwU" control={<Radio className={classes.inputColor} />} label="UwU" />
                                  <FormControlLabel value="Eyes,VR" control={<Radio className={classes.inputColor} />} label="VR" />
                                  <FormControlLabel value="Eyes,X_X" control={<Radio className={classes.inputColor} />} label="X_X" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                              {/* START OF SUB ACCORDION */}
                              <Accordion className={classes.accordion}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{ borderBottom: '1px solid black', padding: '0' }}
                                >
                                  <Typography>Background</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: '5px 0', display: 'flex', flexDirection: 'column' }}>
                                  <FormControlLabel value="Background,Blue" control={<Radio className={classes.inputColor} />} label="Blue" />
                                  <FormControlLabel value="Background,Desert" control={<Radio className={classes.inputColor} />} label="Desert" />
                                  <FormControlLabel value="Background,FremontSt" control={<Radio className={classes.inputColor} />} label="FremontSt" />
                                  <FormControlLabel value="Background,Green" control={<Radio className={classes.inputColor} />} label="Green" />
                                  <FormControlLabel value="Background,Moon" control={<Radio className={classes.inputColor} />} label="Moon" />
                                  <FormControlLabel value="Background,Orange" control={<Radio className={classes.inputColor} />} label="Orange" />
                                  <FormControlLabel value="Background,Pink" control={<Radio className={classes.inputColor} />} label="Pink" />
                                  <FormControlLabel value="Background,Red" control={<Radio className={classes.inputColor} />} label="Red" />
                                  <FormControlLabel value="Background,Strip" control={<Radio className={classes.inputColor} />} label="Strip" />
                                  <FormControlLabel value="Background,Yellow" control={<Radio className={classes.inputColor} />} label="Yellow" />
                                </AccordionDetails>
                              </Accordion>
                              {/* END OF SUB ACCORDION */}
                            </RadioGroup>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    }

                    {/* RARITY SECTION */}
                    {/* <Grid item xs={6} md={12}>
                      <Accordion className={classes.accordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon style={{color: 'black'}} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{borderBottom: '1px solid black', padding: '0'}}
                        >
                          <Typography>RARITY</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{padding: '5px 0'}}>
                          <RadioGroup aria-label="sort" name="sortby">
                          <FormControlLabel value="all" control={<Radio className={classes.inputColor} />} label="All" />
                            <FormControlLabel value="common" control={<Radio className={classes.inputColor} />} label="Common" />
                            <FormControlLabel value="uncommon" control={<Radio className={classes.inputColor} />} label="Uncommon" />
                            <FormControlLabel value="rare" control={<Radio className={classes.inputColor} />} label="Rare" />
                            <FormControlLabel value="mythical" control={<Radio className={classes.inputColor} />} label="Mythical" />
                            <FormControlLabel value="legendary" control={<Radio className={classes.inputColor} />} label="Legendary" />
                            <FormControlLabel value="immortal" control={<Radio className={classes.inputColor} />} label="Immortal" />
                          </RadioGroup>
                        </AccordionDetails>
                      </Accordion>
                    </Grid> */}

                  </Grid>
                  
                  {/* <p> 
                    <Link component={RouterLink} to="/collections?filter=head&filter=eyewear&filter=clothing" style={{ color: '#9b9b9b' }}>Multi Filters</Link>
                  </p>
                  <p>
                    <Link component={RouterLink} to="/collections" style={{ color: '#9b9b9b' }}>Position 1</Link>
                  </p>
                  <p>
                    <Link component={RouterLink} to="/collections?position=200" style={{ color: '#9b9b9b' }}>Position 200</Link>
                  </p> */}
                </Grid>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    {currentView === 'nfts' ?
                      collectionsData.map((item: any, index: number) => {
                        let itemName = item.name.split('#');
                        return (
                          <Grid item xs={6} md={alignment == 'module' ? 3 : 4} key={index}>
                            <Paper className={classes.paper}>
              
                              <div className={classes.itemImage}>
                                <img src={`https://lasvegasvp.com/nfts/` + item.image} alt={item.name} style={{ width: '100%' }} />
                              </div>
              
                              <div style={{display: 'flex', justifyContent: 'space-between', padding: '0 15px 15px', marginTop: '-10px' }}>
                                <Typography variant='caption' style={{fontWeight: 'bold', color: 'black'}}>{itemName[0]}</Typography>
                                <Typography variant='caption' style={{fontWeight: 'bold', color: 'black'}}>#{itemName[1]}</Typography>
                              </div>
                              
                              {/* <div style={{padding: '0 15px 15px 15px'}}>
                                <small style={{color: 'gray'}}>{item.name}</small>
                              </div> */}
                              
                            </Paper>
                          </Grid>
                        );
                      })
                    :
                      traitsData.map((trait: any) => {
                        return (
                          trait.metadata.map((item: any, index: number) => {
                            if (item.trait !== 'None') {
                              return (
                                <Grid item xs={6} md={alignment == 'module' ? 3 : 4} key={index}>
                                  <Paper className={classes.paper}>
                                    <div className={classes.itemImage}>
                                      <img src={`https://lasvegasvp.com/nfts/traits/${trait.trait_type}/${item.trait}.png`} alt={item.trait} style={{ width: '100%' }} />
                                    </div>
                    
                                    <div style={{display: 'flex', justifyContent: 'space-between', padding: '0 15px 15px', marginTop: '-10px' }}>
                                      <Typography variant='caption' style={{fontWeight: 'bold', color: 'black'}}>{item.trait}</Typography>
                                      <Typography variant='caption' style={{fontWeight: 'bold', color: 'black'}}>{trait.trait_type}</Typography>
                                    </div>
                                    
                                    <div style={{padding: '0 15px 15px 15px'}}>
                                      <Typography variant="caption" style={{color: 'gray'}}>{item.occurrence}</Typography>
                                    </div>
                                    
                                  </Paper>
                                </Grid>
                              );
                            }
                          })
                        )
                      })
                    }
                  </Grid>
                  {currentView !== 'traits' ?
                    <Grid item xs={12} md={12} container justifyContent="center" style={{ margin: '30px 0' }}>
                      <Pagination 
                        count={Math.round(paginationCount / 24)} 
                        color="primary" 
                        shape="rounded" 
                        className={classes.pagination} 
                        onChange={handlePagination}
                        page={currentPage}
                      />
                    </Grid>
                  : <div style={{ margin: 90 }}></div>
                  }
                </Grid>
              </Grid>
              {/* END OF BODY CONTAINER, DON'T ADD STUFF UNDER HERE */}
            </Container>
          </Paper>
        </Container>
        <Footer />
        <BackToTop />
    </div>
  );
};

export default Collections;